/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/AssistantAndProvider/Content/Change/Content/Chair/Content",
  onChange
  
}) {
let chairsValueData = fromData.useDataValue({ viewPath,
context: 'chairs',
})
let changeChairChairIdValueData = fromData.useDataValue({ viewPath,
context: 'change_chair',
path: 'chair_id',
})
let changeChairChairIdChangeData = fromData.useDataChange({ viewPath,
context: 'change_chair',
path: 'chair_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 data="chairs"
 from={chairsValueData}
 data="change_chair.chair_id"
 value={changeChairChairIdValueData}
 onChange={changeChairChairIdChangeData}
 alignItems="stretch"
 textAlign="left"
 width="100%"
 marginBottom={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Chair"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}